export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    var body = document.body;
    var modal = document.getElementById("video-lightbox");
    var btns = document.querySelectorAll(".audio-button-open");
    var span = document.getElementById("close-lightbox");

    // Initialize Vimeo Player
    var iframe = document.querySelector("#video-lightbox iframe");
    var player = new Vimeo.Player(iframe);

    btns.forEach((btn) => {
      btn.onclick = function () {
        modal.style.display = "block";
        body.style.overflow = "hidden";
        player.setVolume(1);
        player.play();
      };
    });

    span.onclick = function () {
      modal.style.display = "none";
      body.style.overflow = "auto";
      player.setVolume(0);
      player.pause();
    };

    window.onclick = function (event) {
      if (event.target == modal) {
        modal.style.display = "none";
        body.style.overflow = "auto";
        player.setVolume(0);
        player.pause();
      }
    };
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js